module.exports = __webpack_public_path__ + "img/ic_dotread.35216e2a.png";